
const prods = document.querySelectorAll('.custom-featured-products-carousel .embla__slide');
 
function initVideoLogic(prod) {
    const prodImg = prod.querySelector('.card__media img');
    const prodVid = prod.querySelector('video');
    const muteButton = prod.querySelector('.mute-button'); 
    const playBtn = prod.querySelector('.play-btn');

    playBtn.addEventListener('click', function() {

        if(!prodVid.classList.contains('loaded')) {
            prodVid.load();

            prodVid.classList.add('loaded');
    
            prodVid.addEventListener('loadeddata', function() {
                prodImg.classList.add('hidden');
        
                if(!playBtn.classList.contains('playing')) {
                   
                }
        
             
               
            });
        } 

        if(!prodVid.paused) {
            prodVid.pause();
            playBtn.classList.remove('playing');
        } else {
            prodVid.play();
            playBtn.classList.add('playing');
        }
    
    });

    muteButton.addEventListener('click', function() {

        Array.from(document.querySelectorAll('.custom-featured-products-carousel .embla__slide')).map(function(slide) {
      
            const currentMuteBtn = slide.querySelector('.mute-button');
            const currentVid = slide.querySelector('video');

            if(currentMuteBtn.classList.contains('mute')) {
                currentMuteBtn.classList.add('unmute');
                currentMuteBtn.classList.remove('mute');
                if(currentVid) currentVid.muted=false;
              
            } else {
                currentMuteBtn.classList.add('mute');
                currentMuteBtn.classList.remove('unmute');
                prodVid.setAttribute('muted', true);
                if(currentVid) currentVid.muted=true;
            }

        });
       
      
    });
}

    let prodObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {

            if(!video.target.querySelector('video')) {

                const vid = document.createElement('video');
                const source = document.createElement('source');
                const cardMedia = video.target.querySelector('.card__media');
                const img = cardMedia.querySelector('img');

                 vid.muted=true;
                
                const videoLink = cardMedia.getAttribute('data-video');
                
                vid.setAttribute('muted', true);
                vid.setAttribute('playsinline', true);
                vid.setAttribute('loop', true);
                vid.setAttribute('poster', img.getAttribute('src'));
            

                source.setAttribute('src', videoLink);
                source.setAttribute('type', 'video/mp4');

                vid.appendChild(source);
    
                cardMedia.appendChild(vid);
    
                initVideoLogic(video.target);
    
                prodObserver.unobserve(video.target);
            
            }

     
        }
      });
    });


prods.forEach(function(prod) {
    const moreProdsToggle = prod.querySelector('.more-prods-toggle');
    const moreProdsContainer = prod.querySelector('.more-prods-container');


    if(moreProdsToggle) {
        moreProdsToggle.addEventListener('click', function() {
            moreProdsContainer.classList.toggle('open');
        })
    }

    prodObserver.observe(prod);
});

function get_url_extension( url ) {
    return url.split(/[#?]/)[0].split('.').pop().trim();
}